import { createSelector } from '@reduxjs/toolkit';
import type { IUserProfileRecentlyWatchedOffers } from '../../types/userProfile';
import { userProfileClientInfoSelector } from './userProfileClientInfoSelector';

export const userProfileRecentlyWatchedOffersSelector = createSelector(
  [userProfileClientInfoSelector],
  (clientInfo): IUserProfileRecentlyWatchedOffers | null => {
    return clientInfo?.recentlyWatchedOffers || null;
  },
);
